import { Box, Container, Content } from 'react-bulma-components';
import React, { Fragment, useState } from 'react';
import { faAngleDown, faAngleRight, faLightbulb } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Markdown from '../components/markdown';
import { colors } from '../styles';

//import Message from 'react-bulma-components/lib/components/message';

const StepContent = ({header, description, explanation, keytonic, showDetails=false, skipInstrumentTransponation}) => {
  const [detailsHidden, setDetailsHidden ] = useState(!showDetails);
  return (
    <Box>
    <Content>
    
    <h4>{header}</h4>
    <Markdown objectProps={{keytonic: keytonic, skipInstrumentTransponation: skipInstrumentTransponation}}>{description}</Markdown>
    {explanation &&
      <Fragment>
        <br />
        <FontAwesomeIcon icon={faLightbulb} color={colors.primary}/>&nbsp;&nbsp;<a onClick={()=>setDetailsHidden(!detailsHidden)}>Deeper knowledge</a>&nbsp;<FontAwesomeIcon icon={detailsHidden?faAngleRight:faAngleDown} />
        <Container hidden={detailsHidden}>
          <div className="is-divider" data-content="IN DEPTH"></div>
          <Markdown objectProps={{keytonic: keytonic, skipInstrumentTransponation: skipInstrumentTransponation}}>{explanation}</Markdown>
        </Container>
      </Fragment>
    }
    </Content>
  </Box>
  )
};

export default StepContent;